@if (isRelevantUser) {
  <section class="karte"
           [class.karte--offen]="!userTenant.isConfirmed && !userTenant.isRejected"
           [class.karte--fertig]="userTenant.isConfirmed"
           [class.karte--abgelehnt]="userTenant.isRejected">
    <button type="button" class="karte__kopf"
            [attr.aria-expanded]="tenantVisible"
            (click)="tenantVisible = !tenantVisible">
      <mat-icon class="karte__zeichen">
        {{ userTenant.isConfirmed ? 'check_circle' : (userTenant.isRejected ? 'block' : 'error_outline') }}
      </mat-icon>
      <span class="karte__titel">„{{ userTenant.tenantName }}“</span>

      @if (userTenant.isRejected) {
        <span class="stand stand--abgelehnt">Abgelehnt</span>
      } @else if (!userTenant.isConfirmed) {
        <span class="stand stand--offen">Noch zu bestätigen</span>
      }

      <mat-icon class="karte__pfeil">expand_more</mat-icon>
    </button>

    @if (tenantVisible) {
      <div class="karte__inhalt">
        @if (userTenant.isRejected) {
          <!-- invitedByName/-Mail: noch kein Server-Feld, siehe UserTenantDto -->
          <p class="einladung">
            <mat-icon>person_add_alt</mat-icon>
            <span>
              Eingeladen von <strong>{{ userTenant.invitedByName || '–' }}</strong>
              @if (userTenant.invitedByEmail) {
                <span class="einladung__mail">{{ userTenant.invitedByEmail }}</span>
              }
            </span>
          </p>

          <p class="karte__text">Sie haben diese Einladung abgelehnt.</p>
          <!-- rejectionReason: noch keine DB-Spalte, siehe UserTenantDto - Feld
               wird deshalb (noch) leer angezeigt, sobald "Benutzerprofil" neu
               geladen wurde. -->
          <p class="begruendung">
            <span class="begruendung__name">Begründung</span>
            <span>{{ userTenant.rejectionReason }}</span>
          </p>
        } @else if (ablehnenAktiv) {
          <form class="formular formular--eins">
            <mat-form-field appearance="outline" class="mfeld" [class.mfeld--fehlt]="!begruendungEntwurf.trim()">
              <mat-label>Begründung der Ablehnung</mat-label>
              <textarea matInput rows="3"
                        placeholder="z. B. Ich arbeite nicht mehr für diesen Mandanten."
                        [(ngModel)]="begruendungEntwurf" name="begruendung"></textarea>
              <mat-icon matPrefix>edit_note</mat-icon>
            </mat-form-field>
          </form>

          <footer class="karte__fuss karte__fuss--geteilt">
            <button type="button" class="knopf knopf--leise" (click)="ablehnenAbbrechen()">
              <mat-icon>arrow_back</mat-icon>
              <span>Abbrechen</span>
            </button>
            <button type="button" class="knopf knopf--rot" [disabled]="!begruendungEntwurf.trim()" (click)="ablehnenBestaetigen()">
              <mat-icon>block</mat-icon>
              <span>Ablehnung bestätigen</span>
            </button>
          </footer>
        } @else {
          <div class="mandant__zeile">
            <p class="einladung">
              <mat-icon>person_add_alt</mat-icon>
              <span>
                Eingeladen von <strong>{{ userTenant.invitedByName || '–' }}</strong>
                @if (userTenant.invitedByEmail) {
                  <span class="einladung__mail">{{ userTenant.invitedByEmail }}</span>
                }
              </span>
            </p>

            <form [formGroup]="userTenantForm" novalidate>
              <mat-form-field appearance="outline" class="mfeld mandant__telefon">
                <mat-label>Telefonnummer (optional)</mat-label>
                <input matInput type="tel" formControlName="phoneNumber" maxlength="50" />
                <mat-icon matPrefix>call</mat-icon>
              </mat-form-field>
            </form>
          </div>

          @if (!userTenant.isConfirmed) {
            <footer class="karte__fuss" [class.karte__fuss--geteilt]="!warBestaetigt">
              @if (!warBestaetigt) {
                <button type="button" class="knopf knopf--rot" (click)="ablehnenBeginnen()">
                  <mat-icon>block</mat-icon>
                  <span>Ablehnen</span>
                </button>
              }
              <button type="button" class="knopf knopf--voll" [disabled]="userTenantForm.invalid" (click)="confirm()">
                <mat-icon>check</mat-icon>
                <span>Bestätigen</span>
              </button>
            </footer>
          }
        }
      </div>
    }
  </section>
}
